import { render, staticRenderFns } from "./clients-home.vue?vue&type=template&id=427fa7cd"
import script from "./clients-home.vue?vue&type=script&lang=js"
export * from "./clients-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports